<template>
  <div class="d-flex flex-column flex-root" v-if="isAuthenticated">
    <!-- begin:: Header Mobile -->
    <KTHeaderMobile></KTHeaderMobile>
    <!-- end:: Header Mobile -->

    <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>

    <!-- begin::Body -->
    <div class="d-flex flex-row flex-column-fluid page">
      <!-- begin:: Aside Left -->
      <KTAside v-if="asideEnabled"></KTAside>
      <!-- end:: Aside Left -->

      <div id="kt_wrapper" class="d-flex flex-column flex-row-fluid wrapper">
        <!-- begin:: Content -->
        <div
          id="kt_content"
          class="content d-flex flex-column flex-column-fluid"
        >
          <!-- begin:: Content Head -->

          <!-- begin:: Content Head -->
          <!--  <KTSubheader
            v-if="subheaderDisplay"
            v-bind:breadcrumbs="breadcrumbs"
            v-bind:title="pageTitle"
          />-->
          <!-- end:: Content Head -->

          <!-- begin:: Content Body -->
          <div class="d-flex flex-column-fluid" style="padding-bottom: 50px;">
            <div
              :class="{
                'container-fluid': contentFluid,
                container: !contentFluid
              }"
            >
              <!-- begin:: Content SELECT AREA -  JORNADA-->

              <!-- v-if="!routeUsers" -->

              <div
                class="pl-2 pr-2 mt-2 row mb-0 bg-white mx-1 py-3 rounded mb-2 border"
                data-app
              >
                <div class="col-6 alaslq col-sm-6">
                  <vk-select
                    class="my-2"
                    :options="jornadaList"
                    placeholder="Jornada"
                    @input="changeJornada($event)"
                    label="descripcion"
                    :item-value="'id'"
                    solo
                  ></vk-select>
                </div>

                <div class="col-6 alaslq col-sm-6">
                  <vk-select
                    class="my-2"
                    placeholder="Area"
                    :options="cuadroList"
                    @input="changeArea($event)"
                    label="label"
                    :item-value="'id'"
                    solo
                  ></vk-select>
                </div>

                <b-col class="alaslq">
                  <vk-select
                    class="my-2"
                    placeholder="Actividad"
                    :options="actividadList"
                    @input="saveActividad($event)"
                    label="clave_descripcion"
                    :item-value="'id'"
                    solo
                  ></vk-select>
                </b-col>
              </div>

              <div v-if="loading" class="py-3 mb-4 bg-white text-center">
                <b-spinner variant="primary"></b-spinner>
                <h5 class="mt-3">Cargando usuarios...</h5>
              </div>
              <!-- end:: Content SELECT AREA -  JORNADA-->

              <transition name="fade-in-up">
                <router-view />
              </transition>
            </div>
          </div>
        </div>

        <FooterMenu />

        <!--  <KTFooter></KTFooter> -->
      </div>
    </div>
    <!--  <div class="d-none">
        <img v-for="(item,index) in users" :key="index" :src="item.foto" alt="">
    </div>-->
    <!--<KTStickyToolbar v-if="toolbarDisplay"></KTStickyToolbar> -->
    <!--<KTScrollTop></KTScrollTop> -->
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapState } from "vuex";
import KTAside from "@/view/layout/aside/Aside.vue";
import KTHeaderMobile from "@/view/layout/header/HeaderMobile.vue";
//import KTFooter from "@/view/layout/footer/Footer.vue";
import HtmlClass from "@/core/services/htmlclass.service";
//import KTSubheader from "@/view/layout/subheader/Subheader.vue";
//import KTStickyToolbar from "@/view/layout/extras/StickyToolbar.vue";
import FooterMenu from "@/view/layout/FooterMenu/container";
//import KTScrollTop from "@/view/layout/extras/ScrollTop";

import Loader from "@/view/content/Loader.vue";

import ApiService from "@/core/services/api.service"; //Getting

import vSelect from "vue-select";

import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME
} from "@/core/services/store/htmlclass.module.js";

//import BusEvent from "../../busEvent"
Vue.component("vk-select", vSelect);
import "vue-select/dist/vue-select.css";

export default {
  name: "Layout",
  data() {
    return {
      jornadaList: [],
      areaList: [],
      cuadroList: [],
      actividadList: [],
      selectedWorkday: null,
      selectedArea: null
    };
  },
  components: {
    KTAside,
    KTHeaderMobile,
    //  KTFooter,
    //KTSubheader,
    // KTStickyToolbar,
    //  KTScrollTop,
    FooterMenu,
    Loader
  },

  beforeMount() {
    // show page loading
    this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");

    // initialize html element classes
    HtmlClass.init(this.layoutConfig());
  },
  mounted() {
    // check if current user is authenticated
    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
    }

    this.$store.commit("changeLoading", true);

    const self = this;

    this.getJSON("/users.json", function(err, data) {
      if (err !== null) {
        //alert('Something went wrong: ' + err);
      } else {
        self.$store.commit("changeLoading", false);
        self.$store.commit("storeUsers", data.data);
        const url = "https://res.appagricactus.com/upload_/";

        data.data.map(function(x) {
          if (x.foto) {
            var myImage = new Image(100, 200);
            myImage.src = url + x.foto;
          }
        });
        //  console.log(data.data)
      }
    });

    // Simulate the delay page loading
    setTimeout(() => {
      // Remove page loader after some time
      this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
    }, 2000);

    //  this.$store.dispatch("getUsers");

    this.fetchAreas();

    this.fetchJornadas();

    this.fetchActividades();
    this.fetchCuadros();
    this.getAsistenciasOnline();
  },
  watch: {
    networkStateIsOnline(nV) {
      if (nV) {
        const result = ApiService.get("asistencia/day");
        const usersOnline = result.data.data;

        this.$store.dispatch("updateAsistencia", usersOnline);
      } else {
        this.$store.dispatch("getAsistencias");
      }
    }
  },
  methods: {
    getJSON(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "json";
      xhr.onload = function() {
        var status = xhr.status;
        if (status === 200) {
          callback(null, xhr.response);
        } else {
          callback(status, xhr.response);
        }
      };
      xhr.send();
    },
    async getAsistenciasOnline() {
      //Obtiene asistencia al haber conexion  y actualiza Pouch - mode online

      /* let isToday = true

    await this.asistencias.map(function(x){
        const today = new Date().getTime();
        const reqDateVar = new Date(x.date).getTime();

        if(today != reqDateVar){
           isToday = false
        }
     })*/
      if (this.networkStateIsOnline) {
        const result = await ApiService.get("asistencia/day");
        const usersOnline = result.data.data;

        this.$store.dispatch("updateAsistencia", usersOnline);
      } else {
        this.$store.dispatch("getAsistencias");
      }
      /*else{
        const self = this
        this.data.map(function(user){
          const date = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
          const jornada_id = user.jornadaId;
          const user_id = user.usuarioId;
          const areaId = user.areaId;
          self.$store.dispatch("putAsistencia",{ user_id, jornada_id, date, areaId });
        })
     } */
    },
    changeJornada(id) {
      this.$store.commit("saveJornada", id.id);
      //BusEvent.$emit("jornadaId",this.selectedWorkday);
    },
    saveActividad(id) {
      this.$store.commit("saveActividad", id.id);
      //BusEvent.$emit("jornadaId",this.selectedWorkday);
    },
    changeArea(id) {
      this.$store.commit("saveArea", id.id);
      //BusEvent.$emit("areaId",this.selectedArea);
    },

    //Fetch Areas
    fetchAreas() {
      ApiService.get("area").then(res => {
        const areas = res.data.data;
        this.areaList = areas;
      });
    },

    //Fetch Actividad
    fetchActividades() {
      ApiService.get("actividad").then(res => {
        let data = res.data.data;
        data.map(
          x => (x.clave_descripcion = x.clave_actividad + " " + x.descripcion)
        );
        this.actividadList = data;
      });
    },

    //Fetch Cuadros
    fetchCuadros() {
      ApiService.get("cuadro").then(res => {
        // this.cuadroList = res.data.data;
        this.cuadroList = res.data.data.map(cuadro=>{
          cuadro['label'] = `${cuadro.clave_cuadro} - ${cuadro.variedad.descripcion}`;
          return cuadro;
        });
      });
    },

    //Fetch jornadas
    fetchJornadas() {
      ApiService.get("jornada").then(res => {
        const jornadas = res.data.data;
        this.jornadaList = jornadas;
      });
    }
  },
  computed: {
    ...mapState({
      users: state => state.users.users,
      loading: state => state.users.loading,
      asistencias: state => state.asistencias.asistencias,
      networkStateIsOnline: state => state.network.isOnline
    }),
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig"
    ]),

    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },

    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },

    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },

    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },

    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },

    routeUsers() {
      return this.$route.name === "users";
    }
  }
};
</script>

<style>
.col-select {
  padding: 0px;
}

.alaslq .v-text-field__details {
  display: none;
}

.v-input_control {
  margin: 40px !important;
}
</style>
